import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import TitleHeader from 'components/presenters/header/TitleHeader';
import MatchingRoomForm from 'components/presenters/matching/room/MatchingRoomForm';
import server from 'server/serverController2';

export default function UpdateMatchingRoomLayout({match}) {

  const history = useHistory();

  const roomNo = match['params']['room_no'];

  const [valid, setValid] = useState(false);
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [capacity, setCapacity]  = useState(2);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(()=>{
    //get roomInfo
    server.getRequestData(`matching/rooms/${roomNo}`, (res)=>{
      if(res.success !== 1)
      {
        return;
      }
      const jsonData = res.data; 
      if(jsonData?.title)
      {
        setTitle(jsonData.title)
      }
      if(jsonData?.description)
      {
        setDescription(jsonData.description)
      }
      if(jsonData?.max_capacity)
      {
        setCapacity(jsonData.max_capacity)
      }
    })

  },[])
  
  /* eslint-disable react-hooks/exhaustive-deps */ 
  useEffect(()=>{
    validate();
  },[capacity, description, title]);

  const validate = ()=>{
    if([null, undefined].includes(title) || [null, undefined].includes(description) || 
      title.length === 0 || description.length === 0 || capacity < 2 || capacity > 10)
    {
      setValid(false);
      return;
    } 
    setValid(true);
  }

  const handleChange = (updatedField)=>{
    if(updatedField['title'] !== undefined) setTitle(updatedField['title']) ;
    if(updatedField['description'] !== undefined && updatedField['description'].length <= 150) setDescription(updatedField['description']) ;
    if(updatedField['capacity'] !== undefined && updatedField['capacity'] > 1 && updatedField['capacity'] < 11) setCapacity(updatedField['capacity']) ; 
  }
  const handleUpdateRoom = (e)=>{
    const form = {};
    form['title'] = title;
    form['description'] = description;
    form['max_capacity'] = capacity;
    server.putRequestData(`matching/rooms/${roomNo}`, form, (res)=>{
      if(res.success !== 1)
      {
        return;
      }
      history.replace('/matching');
    })
  }

  return (
    <>
      <div style={{height: 'calc(100vw*(51/375))'}}>
        <TitleHeader onBackBtn={null} showComplete={true} isComplete={valid} onCompleteClick={handleUpdateRoom} />
      </div>
      <div>
        <MatchingRoomForm onChange={handleChange} title={title} description={description} capacity={capacity} />
      </div>
    </>
  );
}
